import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Edit, Trash2, Stamp, Plus } from 'lucide-react';
import { getCategoryInfo, getStampTypeInfo } from './constants';

export default function StampsTab({ stamps, openEditStamp, deleteStamp, openStampModal }) {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <div>
          <h3 className="text-lg font-semibold">Collection de Tampons</h3>
          <p className="text-sm text-gray-500">Gérez vos tampons officiels, certifications et personnalisés</p>
        </div>
        <Button onClick={openStampModal} className="bg-purple-600 hover:bg-purple-700" data-testid="add-stamp-btn">
          <Plus className="h-4 w-4 mr-2" />
          Ajouter un tampon
        </Button>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="stamps-grid">
        {stamps.map((stamp) => {
          const typeInfo = getStampTypeInfo(stamp.type);
          return (
            <Card key={stamp.id} className="hover:shadow-md transition-shadow" data-testid={`stamp-card-${stamp.id}`}>
              <CardContent className="pt-4 text-center">
                <div className="w-24 h-24 mx-auto mb-3 rounded-full border-2 border-dashed border-gray-300 flex items-center justify-center bg-gray-50 overflow-hidden">
                  {stamp.image ? (
                    <img src={stamp.image} alt={stamp.name} className="w-20 h-20 object-contain" />
                  ) : (
                    <Stamp className="h-10 w-10 text-gray-400" />
                  )}
                </div>
                <p className="font-medium">{stamp.name}</p>
                <Badge className={`${typeInfo.color} text-white text-xs mt-1`}>{typeInfo.label}</Badge>
                <div className="flex flex-wrap justify-center gap-1 mt-2">
                  {stamp.assignedTo?.map(cat => {
                    const catInfo = getCategoryInfo(cat);
                    return (
                      <Badge key={cat} variant="outline" className="text-xs">
                        {catInfo?.label || cat}
                      </Badge>
                    );
                  })}
                </div>
                <div className="flex justify-center gap-2 mt-3">
                  <Button size="sm" variant="outline" title="Modifier"
                    onClick={() => openEditStamp(stamp)}>
                    <Edit className="h-3 w-3" />
                  </Button>
                  <Button size="sm" variant="outline" className="text-red-600 hover:bg-red-50" title="Supprimer"
                    onClick={() => deleteStamp(stamp.id)}>
                    <Trash2 className="h-3 w-3" />
                  </Button>
                </div>
              </CardContent>
            </Card>
          );
        })}
        
        {stamps.length === 0 && (
          <Card className="col-span-full">
            <CardContent className="py-12 text-center">
              <Stamp className="h-12 w-12 mx-auto text-gray-300 mb-4" />
              <p className="text-gray-500">Aucun tampon dans la collection</p>
              <Button className="mt-4" onClick={openStampModal}>
                <Plus className="h-4 w-4 mr-2" />
                Ajouter votre premier tampon
              </Button>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
}
